import { parseIntuneRawColumn } from './intuneCompliance';

const firstNonEmpty = (...values) => {
  for (const value of values) {
    const trimmed = String(value == null ? '' : value).trim();
    if (trimmed) return trimmed;
  }
  return '';
};

export function getIntuneAssetUpn(asset) {
  const raw = parseIntuneRawColumn(asset?.['intune-raw']);
  if (!raw || typeof raw !== 'object') return '';
  const additional = raw.AdditionalProperties || raw.additionalProperties || {};
  return firstNonEmpty(
    additional.UserPrincipalName,
    additional.userPrincipalName,
    raw.Owner,
    raw.owner
  );
}

export function getAssetAssigneeIdentifiers(asset) {
  if (!asset || typeof asset !== 'object') return [];
  const upn = firstNonEmpty(asset.upn, asset.UPN, getIntuneAssetUpn(asset));
  const username = firstNonEmpty(asset.username, asset.Username, asset.userName);
  const seen = new Set();
  const identifiers = [];
  [upn, username].forEach((value) => {
    if (!value) return;
    const key = value.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    identifiers.push(value);
  });
  return identifiers;
}

export function getUserDisplayName(user) {
  return firstNonEmpty(
    user?.displayName,
    user?.displayname,
    user?.userPrincipalName,
    user?.userprincipalname
  );
}

export function hasStartedAssignedToTyping(currentValue, originalValue) {
  return String(currentValue || '') !== String(originalValue || '');
}

export function buildAssignedToDropdownOptions({
  suggestedUser,
  typeaheadUsers,
  hasTyped
}) {
  if (!hasTyped) {
    const displayName = getUserDisplayName(suggestedUser);
    if (!displayName) return [];
    return [{ ...suggestedUser, displayName, suggested: true }];
  }
  return Array.isArray(typeaheadUsers) ? typeaheadUsers : [];
}
